import "./Table.scss";

export const CustomTable = ({ tableData, loading }) => {

  const headers = tableData && tableData.length > 0
    ? Object.keys(tableData[0])
    : [];

  return (
    <>
      <div className="table-container">
    <div className="table-scroll">
      {loading && (
        <div className="spinner-overlay">
          <div className="spinner"></div>
        </div>
      )}
      
      <table>
        <thead>
          <tr>
            {headers.length > 0 ? (
              headers.map((header, idx) => (
                <th key={idx}>{header}</th>
              ))
            ) : (
              <th colSpan={10}>Loading...</th>
            )}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={headers.length}>Loading...</td>
            </tr>
          ) : tableData && tableData.length > 0 ? (
            tableData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {headers.map((header, colIndex) => (
                  <td key={colIndex}>{row[header] !== "" ? row[header] : "-"}</td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={headers.length}>No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
    </>
  );
};
